export default "__VITE_ASSET__7xtAjRa9__"